import React from 'react'
import { useAppSelector } from '../../../../hooks/redux'

import Table from '../../../../components/molecules/Table'
import StatusDot from '../InboxesColumns/StatusDot'
import OnlineProfile from '../InboxesColumns/OnlineProfile'
import UserOverride from '../InboxesColumns/UserOverrride'
import TeamRestrict from '../InboxesColumns/TeamRestrict'
import EditDelete from '../InboxesColumns/EditDelete'

import { columnHelper } from './helpers'
import { selectBaseInbox } from '../../../../slices/baseInbox'

type InboxesTableProps = {
  openModal: (data: APIBaseInbox) => () => void
}

const InboxesTable: React.FC<InboxesTableProps> = ({ openModal }) => {
  const { loaded, inboxes } = useAppSelector(selectBaseInbox)

  const columns = React.useMemo(() => {
    const statusColumn = columnHelper.display({
      id: 'online_status',
      header: 'Status',
      cell: () => <StatusDot online={false} />
    })

    const nameColumn = columnHelper.accessor('name', {
      header: 'Name',
      cell: ({ row }) => (
        <div style={{ cursor: 'default' }}>{row.original.name}</div>
      )
    })

    const profileColumn = columnHelper.accessor('online_profile', {
      header: 'Profile',
      cell: ({ row }) => <OnlineProfile profile={row.original.online_profile} />
    })

    const userOverrideColumn = columnHelper.accessor('user_override', {
      header: 'User Override',
      cell: ({ row }) => <UserOverride override={row.original.user_override} />
    })

    const restrictionColumn = columnHelper.accessor('all_teams', {
      header: 'Restriction',
      cell: ({ row }) => (
        <TeamRestrict
          allTeams={row.original.all_teams}
          teamRestrict={row.original.team_restrict}
        />
      )
    })

    const editColumn = columnHelper.display({
      id: 'edit',
      header: 'Edit / Delete',
      cell: ({ row }) => <EditDelete open={openModal} data={row.original} />
    })

    return [
      statusColumn,
      nameColumn,
      profileColumn,
      userOverrideColumn,
      restrictionColumn,
      editColumn
    ]
  }, [openModal])

  return (
    <Table
      id='inboxes-table'
      data={inboxes}
      columns={columns}
      loaded={loaded}
      message='There are no inboxes'
      hideCount
      disablePagination
    />
  )
}

export default InboxesTable
